import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ThemeSettingResponse, UpdateThemeSettingRequest } from '@magnetar/admin-api-interfaces'

export const themeSettingService = {
  getThemeSetting: async (
    broadcastDeviceId: number | string,
    token: string,
  ): Promise<ThemeSettingResponse> => {
    try {
      const response = await apiClient.get<ThemeSettingResponse>(
        `/api/broadcast-device/${broadcastDeviceId}/theme_setting`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ThemeSettingResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'GET_THEME_SETTING_FAILED',
          message: '取得主題設定失敗',
        },
      }
    }
  },

  updateThemeSetting: async (
    broadcastDeviceId: number | string,
    data: UpdateThemeSettingRequest,
    token: string,
  ): Promise<ThemeSettingResponse> => {
    try {
      const response = await apiClient.put<ThemeSettingResponse>(
        `/api/broadcast-device/${broadcastDeviceId}/theme_setting`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ThemeSettingResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_THEME_SETTING_FAILED',
          message: '更新主題設定失敗',
        },
      }
    }
  },
}
